import { render, staticRenderFns } from "./marker-card.vue?vue&type=template&id=5ed1169b&scoped=true"
import script from "./marker-card.ts?vue&type=script&lang=ts&external"
export * from "./marker-card.ts?vue&type=script&lang=ts&external"
import style0 from "./marker-card.scss?vue&type=style&index=0&id=5ed1169b&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ed1169b",
  null
  
)

export default component.exports